import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    position:'absolute',
    left:0,
    right:0,
    top:0,
    bottom:0,
    zIndex:0
  },
  loader: {
    height: "70vh",
  },
}));

export default useStyles;
